import React from 'react';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link';
import cx from 'classnames';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import carPlaceholderImg from 'shared/assets/images/car.svg';
// import LazyLoad from 'react-lazyload';
import ThumbCarousel from '../ThumbCarousel/ThumbCarousel';
import s from './Thumb.css';

const DEFAULT_HEIGHT = 170;

class Thumb extends React.Component {
  static propTypes = {
    photos: PropTypes.arrayOf(PropTypes.shape()),
    width: PropTypes.number,
    maxCount: PropTypes.number,
    lensEvent: PropTypes.string,
    link: PropTypes.string,
    style: PropTypes.shape(),
    className: PropTypes.string.isRequired,
    defaultImg: PropTypes.string,
    alt: PropTypes.string,
    setRatioAlbum: PropTypes.func.isRequired,
    isLazy: PropTypes.bool,
  };
  static defaultProps = {
    photos: [],
    maxCount: 5,
    link: '',
    lensEvent: '',
    style: {},
    defaultImg: null,
    className: '',
    alt: '',
    width: 240,
    isLazy: true,
  };

  state = {
    index: 0,
  };

  getResizedImages = () => {
    const { photos, width, style, setRatioAlbum } = this.props;
    const height = parseInt(style.height, 10);

    return setRatioAlbum(photos, width, height || DEFAULT_HEIGHT);
  };

  handleSlideMouseOver = index => {
    const photos = this.getResizedImages();
    const image = new Image();

    image.src = photos[index] && photos[index].image;
    image.onload = () => {
      this.setState({ index });
    };
  };

  render() {
    const { maxCount, link, style, className, defaultImg, lensEvent, alt, isLazy } = this.props;

    const photos = this.getResizedImages();
    const { index } = this.state;
    const album = photos.length && photos.length > maxCount ? photos.slice(0, maxCount) : photos;

    const hasPhotos = photos.length > 0 && photos[index].image;
    const thumbnail =
      hasPhotos && photos[index].image ? photos[index].image : defaultImg || carPlaceholderImg;

    return (
      <div className={cx(s.tmb, className, { [s.placeholderImg]: !hasPhotos })} style={style}>
        {link ? (
          <Link to={link} data-lens-event={lensEvent}>
            <ThumbCarousel index={index} album={album} onMouseOver={this.handleSlideMouseOver} />
          </Link>
        ) : (
          <ThumbCarousel index={index} album={album} onMouseOver={this.handleSlideMouseOver} />
        )}
        <img
          {...(isLazy ? { loading: 'lazy' } : {})}
          className={s.img}
          src={thumbnail.image || thumbnail}
          alt={alt}
          width="230"
          height="194"
        />
      </div>
    );
  }
}

export default withStyles(s)(withPixelRatio(Thumb));



// WEBPACK FOOTER //
// ./src/desktop/components/Thumb/Thumb.js